import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-top-right-corner"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowTopRightCorner"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 7H16.293L10.293 13L11 13.707L17 7.70703V13H18V6H11V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowTopRightCorner;
